/**
 * Filter all the errors that contain a flightId
 *
 * @param {Array} errors
 *
 * @returns {Array}
 */
export default errors => errors.filter(({ data = {} }) => data.flightId)
